
export default {
  name: 'Menu',

  data: function () {
    return {
      openMenuSlugs: [],
    };
  },

  computed: {
    componentLinkHead: function () {
      if (!process?.client) {
        return 'nuxt-link';
      }
      if (window.innerWidth < 1024) {
        return 'div';
      }
      return 'nuxt-link';
    },

    menuList: function () {
      let items = this.$store.state?.cms?.menus?.default?.items || [];
      items = items.filter((t) => !t.isHidden);
      items = items.map((item) => ({
        ...item,
        children: (item?.children || []).filter((t) => !t.isHidden),
      }));

      return items;
    },
  },

  methods: {
    changeOpenMenuSlugs: function (menuItem) {
      const openMenuSlugs = [...this.openMenuSlugs];

      const findIndex = openMenuSlugs.findIndex((t) => t === menuItem.alias);
      if (findIndex > -1) {
        openMenuSlugs.splice(findIndex, 1);
      } else {
        openMenuSlugs.push(menuItem.alias);
      }

      this.openMenuSlugs = openMenuSlugs;
    },
  },
};
